import { render } from "./paymentCouponsModel.vue?vue&type=template&id=e644636e"
import script from "./paymentCouponsModel.vue?vue&type=script&lang=js"
export * from "./paymentCouponsModel.vue?vue&type=script&lang=js"

import "./paymentCouponsModel.vue?vue&type=style&index=0&id=e644636e&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__